import React, { useState } from 'react';
import { KitchenCanvas } from './KitchenCanvas';
import { EnhancedSidebar } from './EnhancedSidebar';
import { TopMenu } from './TopMenu';
import { RadialMenu } from './RadialMenu';
import { ColorMaterialMenu } from './ColorMaterialMenu';
import { ProjectTreeMenu } from './ProjectTreeMenu';
import { PropertiesPanel } from './PropertiesPanel';
import { useTheme } from './ThemeProvider';
interface KitchenBuilderProps {
  roomData: any;
}
export function KitchenBuilder({
  roomData
}: KitchenBuilderProps) {
  const {
    isDarkMode,
    toggleDarkMode
  } = useTheme();
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [radialMenu, setRadialMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    objectType: null
  });
  const [colorMenu, setColorMenu] = useState({
    visible: false,
    x: 0,
    y: 0
  });
  const [projectTreeMenu, setProjectTreeMenu] = useState({
    visible: false,
    x: 0,
    y: 0
  });
  const [copiedStyle, setCopiedStyle] = useState(null);
  const [notes, setNotes] = useState([]);
  const [showPropertiesPanel, setShowPropertiesPanel] = useState(false);
  const handleUnitSelect = unit => {
    setSelectedUnit(unit);
    // Open properties panel when a unit is selected
    setShowPropertiesPanel(true);
  };
  const handleUpdateUnit = updatedUnit => {
    // Handle updating the selected unit's properties
    setSelectedUnit(updatedUnit);
  };
  const handleCanvasClick = e => {
    // Hide menus when clicking on canvas
    setRadialMenu({
      ...radialMenu,
      visible: false
    });
    setColorMenu({
      ...colorMenu,
      visible: false
    });
    setProjectTreeMenu({
      ...projectTreeMenu,
      visible: false
    });
  };
  const handleCanvasRightClick = (e, unit) => {
    e.preventDefault();
    if (unit) {
      // Show radial menu for the unit
      setRadialMenu({
        visible: true,
        x: e.clientX,
        y: e.clientY,
        objectType: unit.category || 'cabinet'
      });
      // Hide other menus
      setColorMenu({
        ...colorMenu,
        visible: false
      });
      setProjectTreeMenu({
        ...projectTreeMenu,
        visible: false
      });
      // Select the unit
      setSelectedUnit(unit);
    } else {
      // Right-click on empty canvas - show project tree menu
      setProjectTreeMenu({
        visible: true,
        x: e.clientX,
        y: e.clientY
      });
      // Hide other menus
      setRadialMenu({
        ...radialMenu,
        visible: false
      });
      setColorMenu({
        ...colorMenu,
        visible: false
      });
    }
  };
  const handleRadialAction = (action, subAction) => {
    console.log(`Action: ${action}`, subAction ? `Sub-action: ${subAction}` : '');
    switch (action) {
      case 'material':
        setColorMenu({
          visible: true,
          x: radialMenu.x,
          y: radialMenu.y
        });
        break;
      case 'editProperties':
        // Show properties panel
        setShowPropertiesPanel(true);
        break;
      case 'copyStyle':
        if (selectedUnit) {
          setCopiedStyle({
            material: selectedUnit.material,
            color: selectedUnit.color,
            finish: selectedUnit.finish
          });
          // Show confirmation toast or notification
          console.log('Style copied');
        }
        break;
      case 'note':
        if (selectedUnit && subAction) {
          const noteNumber = parseInt(subAction);
          setNotes([...notes, {
            id: Date.now(),
            number: noteNumber,
            unitId: selectedUnit.id,
            text: `Note ${noteNumber}`,
            x: radialMenu.x,
            y: radialMenu.y
          }]);
          console.log(`Added note #${noteNumber} to unit`);
        }
        break;
      case 'group':
        console.log('Group items action');
        // Implement grouping logic
        break;
      default:
        // Handle other actions
        break;
    }
  };
  const handleTopMenuAction = (action, data) => {
    console.log(`Top menu action: ${action}`, data);
    if (action === 'toggleDarkMode') {
      toggleDarkMode();
    }
    // Handle other actions from top menu
  };
  const handleMaterialSelect = material => {
    console.log('Selected material:', material);
    // Apply material to selected unit
  };
  const handleProjectTreeAction = action => {
    console.log(`Project tree action: ${action}`);
    // Handle project tree actions
  };
  const handlePropertiesClose = () => {
    setShowPropertiesPanel(false);
  };
  return <div className="flex flex-col h-full dark:bg-darkbg-primary" data-id="element-271">
      <TopMenu onAction={handleTopMenuAction} isDarkMode={isDarkMode} onToggleDarkMode={toggleDarkMode} data-id="element-272" />
      <div className="flex flex-1 overflow-hidden" data-id="element-273">
        {/* Left sidebar - Enhanced sidebar with units library */}
        <EnhancedSidebar onUnitSelect={handleUnitSelect} showProperties={false} // We're using our new PropertiesPanel instead
      onPropertiesClose={handlePropertiesClose} data-id="element-274" />
        {/* Main canvas area */}
        <div className="flex-1 relative" onClick={handleCanvasClick} data-id="element-275">
          <KitchenCanvas roomData={roomData} selectedUnit={selectedUnit} onUnitRightClick={handleCanvasRightClick} onUnitSelect={handleUnitSelect} notes={notes} data-id="element-276" />
          {/* Radial context menu */}
          {radialMenu.visible && <RadialMenu position={{
          x: radialMenu.x,
          y: radialMenu.y
        }} onClose={() => setRadialMenu({
          ...radialMenu,
          visible: false
        })} onAction={handleRadialAction} objectType={radialMenu.objectType} onShowProperties={() => setShowPropertiesPanel(true)} data-id="element-277" />}
          {/* Color & Material menu */}
          {colorMenu.visible && <ColorMaterialMenu position={{
          x: colorMenu.x,
          y: colorMenu.y
        }} onClose={() => setColorMenu({
          ...colorMenu,
          visible: false
        })} onSelect={handleMaterialSelect} data-id="element-278" />}
          {/* Project Tree Context Menu */}
          {projectTreeMenu.visible && <ProjectTreeMenu position={{
          x: projectTreeMenu.x,
          y: projectTreeMenu.y
        }} onClose={() => setProjectTreeMenu({
          ...projectTreeMenu,
          visible: false
        })} onAction={handleProjectTreeAction} data-id="element-279" />}
          {/* Properties Panel */}
          {showPropertiesPanel && selectedUnit && <PropertiesPanel selectedUnit={selectedUnit} onClose={handlePropertiesClose} onUpdate={handleUpdateUnit} data-id="element-280" />}
        </div>
      </div>
    </div>;
}